
export const setErrorAction = err => {
  return {
    type: 'SET_ERROR',
    data: err,
  };
};
